// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__PQYVe","main":"MainLayout_main__5-2a7"};